import {packSession} from '../session/sessionAPI'
import {createSetlistZip} from '../../factories/Zipper';
import { triggerBlobDownload } from '../../factories/ui';

import { getAsset, removeAssetFromCache } from "../../services/assetStore";

export const cacheAssets = async (assetUrls, progressCallback) => {
  try {
    let cachedCount = 1;
    for (const assetUrl of assetUrls) {
      await getAsset(assetUrl, true, ()=>{});
      progressCallback(cachedCount/assetUrls.length);
      cachedCount++;
    }
  return true
  } catch (e) {
    throw Error('Could not cache assets');
  }
}

export const uncacheAssets = async (assetUrls) => {
  try {
    for (const assetUrl of assetUrls) {
      await removeAssetFromCache(assetUrl);
    }
  return true
  } catch (e) {
    throw Error('Could not cache assets');
  }
}


export const packSetlist = async (sessions) => {

  // create a zip of each session
  const sessionZips = {};

  for (const session of sessions) {
    sessionZips[session.id] = await packSession(session);
  }

  // Cretae new zip file
  const setListZip = await createSetlistZip(sessionZips);

  return setListZip;
    
}


